import React from 'react';
import { Hero } from '../Hero/Hero';
import './Home.css';

export const Home = () => {
  return (
    <div className="home-section">
      <div className="home-stars-bg" />
      <Hero />
    </div>
  );
};
